import { cva } from 'class-variance-authority';
import { ElementIntent } from '../../enums';
export const buttonStyling = cva([
    'flex items-center justify-center gap-1 text-nowrap h-fit font-normal disabled:cursor-not-allowed group',
    'transition-colors rounded-full',
], {
    variants: {
        variant: {
            primary: 'bg-gray-900 text-white hover:bg-indigo-400',
            secondary: 'bg-white border border-gray-100 text-gray-700 hover:bg-gray-800 hover:text-white hover:border-gray-900',
            ghost: 'bg-transparent text-gray-700 hover:bg-gray-50',
            text: 'bg-transparent text-gray-900 hover:underline',
        },
        intent: {
            [ElementIntent.Info]: '',
            [ElementIntent.Success]: '',
            [ElementIntent.Warning]: '',
            [ElementIntent.Danger]: '',
        },
        size: {
            sm: 'text-xs py-2 px-3',
            md: 'text-sm py-2.5 px-3.5',
            lg: 'text-sm py-3.5 px-5',
        },
        withIcon: {
            true: '',
            false: '',
        },
        withChildren: {
            true: '',
            false: '',
        },
        isDisabled: {
            true: 'cursor-not-allowed',
            false: '',
        },
    },
    compoundVariants: [
        { withIcon: true, withChildren: false, className: 'gap-1' },
        { withIcon: false, withChildren: true, className: 'gap-2' },
        { withIcon: true, withChildren: true, className: 'gap-2.5' },
        // Primary intent variants
        { variant: 'primary', intent: ElementIntent.Info, className: 'bg-blue-500 hover:bg-blue-600 text-white' },
        { variant: 'primary', intent: ElementIntent.Success, className: 'bg-green-500 hover:bg-green-600 text-white' },
        { variant: 'primary', intent: ElementIntent.Warning, className: 'bg-yellow-500 hover:bg-yellow-600 text-white' },
        { variant: 'primary', intent: ElementIntent.Danger, className: 'bg-red-400 hover:bg-red-500 text-white' },
        // Secondary intent variants
        { variant: 'secondary', intent: ElementIntent.Info, className: 'border-blue-500 text-blue-700 hover:bg-blue-50' },
        { variant: 'secondary', intent: ElementIntent.Success, className: 'border-green-500 text-green-700 hover:bg-green-50' },
        { variant: 'secondary', intent: ElementIntent.Warning, className: 'border-yellow-500 text-yellow-700 hover:bg-yellow-50' },
        { variant: 'secondary', intent: ElementIntent.Danger, className: 'border-red-400 text-red-600 hover:bg-red-50' },
        // Ghost intent variants
        { variant: 'ghost', intent: ElementIntent.Info, className: 'text-blue-700 hover:bg-blue-50' },
        { variant: 'ghost', intent: ElementIntent.Success, className: 'text-green-700 hover:bg-green-50' },
        { variant: 'ghost', intent: ElementIntent.Warning, className: 'text-yellow-700 hover:bg-yellow-50' },
        { variant: 'ghost', intent: ElementIntent.Danger, className: 'text-red-700 hover:bg-red-50' },
        // Text intent variants
        { variant: 'text', intent: ElementIntent.Info, className: 'text-blue-700' },
        { variant: 'text', intent: ElementIntent.Success, className: 'text-green-700' },
        { variant: 'text', intent: ElementIntent.Warning, className: 'text-yellow-700' },
        { variant: 'text', intent: ElementIntent.Danger, className: 'text-red-700' },
    ],
    defaultVariants: {
        variant: 'primary',
        size: 'md',
    },
});
export const iconStyling = cva('', {
    variants: {
        size: {
            sm: 'size-3.5',
            md: 'size-4',
            lg: 'size-5',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
